import { useEffect, useState } from "react";
import { useTitleBar } from "@/context/TitleBarProvider";
import { RefreshCw, Table, Plus } from "lucide-react";
import { WorkspacesListSection } from "@/components/workspaces/WorkspacesListSection";
import { Button } from "@/components/ui/button";
import { useWorkspacesQuery } from "@/hooks/useWorkspacesQuery";
import AutomateProcessButton from "@/components/processes/AutomateProcessButton";
import { CreateWorkspaceModal } from "@/components/workspaces/CreateWorkspaceModal";
import { useAdminStatus } from "@/hooks/useAdminStatus";

const WorkspacesPage = () => {
  const { setTitle, setIcon, setButtons } = useTitleBar();
  const { refetch, isFetching } = useWorkspacesQuery();
  const { isAdmin } = useAdminStatus();
  const [createModalOpen, setCreateModalOpen] = useState(false);

  useEffect(() => {
    setTitle("Workspaces");
    setIcon(<Table size={24} />);
    setButtons(
      <>
        <AutomateProcessButton />
        {isAdmin && (
          <Button onClick={() => setCreateModalOpen(true)}>
            <Plus size={20} className="mr-1" />
            Create Workspace
          </Button>
        )}
        <Button
          variant="outline"
          onClick={() => refetch()}
          disabled={isFetching}
        >
          <RefreshCw size={20} className={isFetching ? "animate-spin" : ""} />
          Refresh
        </Button>
      </>
    )
  }, [setTitle, setIcon, setButtons, isFetching, refetch, isAdmin]);

  return (
    <div>
      <CreateWorkspaceModal
        open={createModalOpen}
        onOpenChange={setCreateModalOpen}
      />
      <WorkspacesListSection />
    </div>
  );
};

export default WorkspacesPage;
